"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function default_1(_a) {
    var error = _a.error, timedOut = _a.timedOut, pastDelay = _a.pastDelay;
    var reload = React.useCallback(function () {
        window.location.reload();
    }, []);
    if (error) {
        return (React.createElement("div", null,
            "Error!",
            React.createElement("button", { type: "button", onClick: reload }, "Retry")));
    }
    if (timedOut) {
        return (React.createElement("div", null,
            "Taking a long time...",
            React.createElement("button", { type: "button", onClick: reload }, "Retry")));
    }
    if (pastDelay) {
        return React.createElement("div", null, "Loading...");
    }
    return null;
}
exports.default = default_1;
//# sourceMappingURL=Loading.js.map